<template>
  <div class="tw-leading-[14px] tw-text-[11px]" :class="subtitleClass">
    <slot name="icon"></slot>
    <span>
      <slot />
    </span>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

interface Props {
  dimmed?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  dimmed: false,
})

const subtitleClass = computed(() => {
  return props.dimmed ? 'tw-text-sf-gray-lighter' : 'tw-text-sf-gray-light'
})
</script>
